import { createApp, defineCustomElement } from 'vue';
import { find } from 'lodash';
import App from './App';
import router from './router';
import store from './store';
import LocalizedLabel from './components/LocalizedLabel';
import ImageHandler from './components/ImageHandler';
import i18n from './i18n';
import { getConfiguration, themes } from './utility';
import SkeletonLoader from './components/SkeletonLoader.ce';

const ROUTES = {
  BADGE: 'badge',
  MODULES: 'modules',
};

const setTheme = (theme) => {
  if (!theme) {
    store.state.theme = 'dark';
    return;
  }
  // We use only two values because assets for the dark themes are the same
  store.state.theme = themes[theme];
};

(async () => {
  const config = getConfiguration();
  const { theme } = config;
  const language = config?.language || 'en';
  const translations = (await i18n.boost(language)).default;
  const path = window.location.pathname === '/' ? window.location.pathname : window.location.pathname.replace(/\/+$/, '');
  const route = find(router.options.routes, { path });
  if (route) {
    config.route = route?.name;
  } else {
    // eslint-disable-next-line
    console.error(`[BOOST]: ${window.location.pathname} is not valid boost route`);
  }
  store.state.translations = translations;
  store.state.config = config;
  setTheme(theme);

  const app = createApp(App)
    .use(router)
    .use(store)
    .use(LocalizedLabel)
    .component('ImageHandler', ImageHandler)
    .mount('#app');

  if (!config.visibleBadge && config.route === ROUTES.MODULES) {
    const skeletonLoaderComponent = defineCustomElement(SkeletonLoader);
    customElements.define('skeleton-loader', skeletonLoaderComponent);
  }

  if (window.Cypress) {
    window.app = app;
  }
})();
